import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../data.service';
import { urls } from '../urls';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { throttle } from 'lodash';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltip } from '@angular/material/tooltip';


@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class ProductDetailComponent implements OnInit {
  isScrollable = true;
  condition: boolean = true;
  scrollLeftVisible = true;
  scrollRightVisible = true;
  msnDetails: any;
  productId: string;

  searchCategoryID: any;
  searchProductId: any;
  searchOpenString: String = '';
  brandIDs: any[];
  selectedBrands = [];
  brandFilterControl: FormControl = new FormControl();
  selectedBrandOptions: any[] = [];
  sor: string = "";
  msnGroupId: string;

  sortedCategoryHierarchy: { key: string; value: any; }[];
  categoryId: any;
  imageprefix = urls.s3Link;
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('copyTooltip') copyTooltip!: MatTooltip;


  panelOpenState = false;
  dataSource;
  columnsToDisplay;
  expandedElement: any;
  pageNumber: number;
  selectedSortingAttribute = "";
  sortingOrder = '1';
  expandedSingleGroupData: any = [];
  staticColumns: string[] = ['MSNItemDescription'];
  dynamicColumnsForSingleGroup: string[] = [];
  displayedColumns;
  isLoading = false;
  pageSize = 10;
  private throttledScrollHandler: () => void;
  private hasMoreSingleGroupData = true;
  showAllKeyFeaturesForEachMsn: { [key: string]: boolean } = {};
  selectedCountryName: string;
  threshold = 50

  checkScrollable(): void {
    if (this.scrollContainer != undefined) {
      const container = this.scrollContainer.nativeElement;
      this.isScrollable = container.scrollWidth > container.clientWidth;
      this.updateScrollButtonVisibility(container.scrollLeft);
    }
  }
  checkOverflow(element) {
    return element.offsetHeight < element.scrollHeight ||
      element.offsetWidth < element.scrollWidth;
  }




  updateScrollButtonVisibility(scrollLeft: number): void {
    const container = this.scrollContainer.nativeElement;
    this.scrollLeftVisible = scrollLeft > 0;
    this.scrollRightVisible = container.scrollWidth - container.clientWidth > scrollLeft;
  }



  scrollRight(): void {
    const container = this.scrollContainer.nativeElement;
    const scrollAmount = 70; // Adjust the scroll amount as per your requirements
    container.scrollLeft += scrollAmount;
    this.updateScrollButtonVisibility(container.scrollLeft);
  }




  scrollLeft(): void {
    const container = this.scrollContainer.nativeElement;
    const scrollAmount = 70; // Adjust the scroll amount as per your requirements
    container.scrollLeft -= scrollAmount;
    this.updateScrollButtonVisibility(container.scrollLeft);
  }

  selectedImageIndex = 0;

  selectImage(index: number) {
    this.selectedImageIndex = index;
  }


  showMore: boolean = false;
  supp: boolean = false;



  constructor(private service: DataService, private paramRoute: ActivatedRoute, private router: Router, private dataService: DataService, private snackBar: MatSnackBar) {
    this.throttledScrollHandler = throttle(this.onScrollSingleGroup.bind(this), 500);
    this.selectedCountryName = dataService.getSelectedCountryName().toUpperCase();
  }

  ngOnInit(): void {

    const storedSupplierAvailable = localStorage.getItem('suplier');
    if (storedSupplierAvailable !== null) {
      const supplierAvailable = JSON.parse(storedSupplierAvailable);
      this.supp = supplierAvailable;
    }
    this.paramRoute.queryParams.subscribe(params => {
      this.productId = params['productId'];
      this.categoryId = params['category'];
    });

    if (this.productId != null)
      this.getMsnDetails();
    this.breadCrumDataBy();
  }

  getMsnDetails(): any {
    this.service.onSpinner()
    let url = urls.productDetails + this.productId;

    this.service.callRestful('GET', url, null, null, null, null).subscribe(this.processResult.bind(this));
    this.dataService.eventTracker("CIS-PORTAL", "PDP-Page", "", "/product-detail");
  }

  processResult(data) {
    this.service.offSpinner()
    if (data.status) {

      this.msnDetails = data;
      this.getGroupDataForMsn(this.msnDetails.cisGroupId);

    } else {
      this.router.navigateByUrl("no-result-found");
      this.service.showMessage('error', data.message);
    }
  }

  getGroupDataForMsn(groupId) {

    this.pageNumber = 0;
    let url = urls.search + "cis/group/products?pageNo=" + this.pageNumber + "&pageSize=" + this.pageSize;

    let payload = {
      'cisGroupId': groupId,
      'sortingAttribute': this.selectedSortingAttribute,
      'sortingOrder': this.sortingOrder
    }

    this.dataService.callRestful('POST', url, payload, null, null, null).subscribe(data => {
      if (data.status && data.data) {
        this.expandedSingleGroupData = data.data;
        this.dataSource = this.expandedSingleGroupData
        this.staticColumns = ['MSNItemDescription']
        this.dynamicColumnsForSingleGroup = this.extractAttributeKeys(this.expandedSingleGroupData);
        console.log(this.dynamicColumnsForSingleGroup)
        this.displayedColumns = [...this.staticColumns, ...this.dynamicColumnsForSingleGroup];
        this.staticColumns = ['uom', 'MRP', 'listPrice', 'TPTxn']
        this.displayedColumns.push(...this.staticColumns)
        console.log(this.displayedColumns)

        this.updateSupplierDetailsForSingleGroup();

        console.log(this.expandedSingleGroupData)
        this.isLoading = false;

        this.dataService.offSpinner()
      } else {
        this.isLoading = false;

        this.dataService.offSpinner()
      }
    })
  }

  extractAttributeKeys(data: any[]): string[] {
    const columns = new Set<string>();

    data.forEach(item => {
      if (item.attributeValuesForPart) {
        Object.keys(item.attributeValuesForPart).forEach(key => {
          columns.add(key); // Extract keys from attributeValuesForPart
        });
      }
    });

    return Array.from(columns);
  }

  @HostListener('scroll', ['$event'])
  onScrollSingleGroup = throttle(function (event: Event) {
    if (!this.hasMoreSingleGroupData || this.isLoading) return;


    const scrollContainer = (event.target as HTMLElement);
    const scrollPosition = scrollContainer.scrollTop + scrollContainer.clientHeight;
    const scrollHeight = scrollContainer.scrollHeight;

    if (scrollHeight - scrollPosition < this.threshold && !this.isLoading) {
      console.log("scrolling down");
      this.getDataForSingleGroup(this.msnDetails.cisGroupId, this.sortingOrder, this.selectedSortingAttribute);
    }
  }, 300); // Adjust the debouncing delay as needed



  getDataForSingleGroup(groupId: string, sortingOrder: string, sortingAttribute: string) {
    if (this.isLoading || !this.hasMoreSingleGroupData) return; // Prevent further requests

    this.isLoading = true;
    console.log('has more single group data', this.hasMoreSingleGroupData)
    this.selectedSortingAttribute = sortingAttribute;
    let payload = {
      'cisGroupId': groupId,
      'sortingAttribute': sortingAttribute,
      'sortingOrder': sortingOrder
    }
    this.pageNumber++;


    let url = urls.search + "cis/group/products?pageNo=" + this.pageNumber + "&pageSize=" + this.pageSize;

    this.dataService.callRestful('POST', url, payload, null, null, null).subscribe(this.processDataForSingleGroup.bind(this))
  }

  processDataForSingleGroup(data) {

    // Check if data is an array and has no items
    if (Array.isArray(data.data) && data.data.length === 0) {
      this.hasMoreSingleGroupData = false;  // Stop further API calls
      this.dataService.offSpinner()
    }

    else if (data.status && data.data) {
      this.expandedSingleGroupData = [...this.expandedSingleGroupData, ...data.data];
      this.staticColumns = ['MSNItemDescription']
      this.dynamicColumnsForSingleGroup = this.extractAttributeKeys(this.expandedSingleGroupData);
      this.displayedColumns = [...this.staticColumns, ...this.dynamicColumnsForSingleGroup];
      this.staticColumns = ['uom', 'MRP', 'listPrice', 'TPTxn']
      this.displayedColumns.push(...this.staticColumns)

      this.updateSupplierDetailsForSingleGroup();

      console.log(this.expandedSingleGroupData)
      this.isLoading = false;

      this.dataService.offSpinner()
    } else {
      this.isLoading = false;

      this.dataService.offSpinner()
    }
  }

  displaySortedGroupDetails(groupId, sortingAttribute) {
    debugger
    if (sortingAttribute == this.selectedSortingAttribute && this.sortingOrder == '1') {
      this.sortingOrder = "2";
    }
    else {
      this.sortingOrder = "1";
    }
    this.selectedSortingAttribute = sortingAttribute
    this.getGroupDataForMsn(groupId)
    // let payload = {
    //   'cisGroupId':groupId,
    //   'sortingAttribute':sortingAttribute,
    //   'sortingOrder': this.sortingOrder
    // }

    // let url = urls.search + "cis/group/products?pageNo=" + this.pageNumber + "&pageSize=" + this.pageSize;
    // this.selectedSortingAttribute = sortingAttribute
    // this.dataService.callRestful('POST',url,payload,null, null, null).subscribe(this.processDataForSingleGroup.bind(this))
  }

  updateSupplierDetailsForSingleGroup() {
    // Iterate through each item in the array
    this.expandedSingleGroupData.forEach(item => {
      // Check if supplierAvailable is true
      if (item.supplierAvailable) {
        // Show the spinner before making API calls
        this.dataService.onSpinner();

        // Prepare the API request
        let body = {
          "warehouseIds": []
        };
        let url = `${urls.supplierDetails}?productId=${item.moglixPartNumber}&pageNo=0&pageSize=1&orderBy=desc`;

        // Make the API call
        this.dataService.callRestful('POST', url, body, null, null, null, false).subscribe(response => {
          // Update the item with the fetched data under the 'TP' field
          if (response?.data?.supplierDetails?.length > 0) {
            item['tp'] = response.data.supplierDetails[0].lastTp;
            item['txn_date'] = response.data.supplierDetails[0].lastTransactionDate;
          }
          // console.log(`Updated item with TP for ${item.moglixPartNumber}:`, item);
        }, error => {
          console.error(`Error fetching details for ${item.moglixPartNumber}:`, error);
        });
      }
    });
  }

  getMRP(mrp: any) {
    if (mrp != null) {
      const key = Object.keys(mrp);
      return mrp[key[0]];
    }
  }

  productSupplier(msn) {

    const queryParams: any = {};


    queryParams.category = this.categoryId;
    queryParams.productId = msn;

    if (this.sor) {
      queryParams.sor = this.sor;
    } else {
      queryParams.sor = "CIS";
    }


    const url = this.router.createUrlTree(['/supplier-discovery'], { queryParams }).toString();

    window.open(url, '_blank');
  }


  breadCrumDataBy(): Promise<any> {
    if (this.categoryId) {
      return new Promise<any>((resolve, reject) => {
        this.service.getBreadCrumData(this.categoryId).subscribe(
          (data) => {
            const categoryIdHirarchy = data['categoryHierarchy'];
            this.sortedCategoryHierarchy = Object.keys(categoryIdHirarchy)
              .filter((key) => key.startsWith('category_name_level') && categoryIdHirarchy[key] !== null)
              .sort()
              .map((key) => ({ key: key, value: categoryIdHirarchy[key] }));

            // Get the value of 'category_name' and append it to the sortedCategoryHierarchy array
            const category_name = categoryIdHirarchy['category_name'];
            if (category_name) {
              this.sortedCategoryHierarchy.push({ key: 'category_name', value: category_name });
            }

            resolve(this.sortedCategoryHierarchy);
          },
          (error) => {
            // Handle error if necessary
            console.error(error);
            reject(error);
          }
        );
      });
    }
  }


  toggleTable() {
    this.showMore = !this.showMore;

  }

  // Event handler for open filter change
  onCategoryFilterChange(categoryName: string) {
    console.log('Selected Category:', categoryName);
  }
  onOpenFilterChange(openFilterValue: string) {
    console.log('Open filter changed:', openFilterValue);
  }
  onSearchFilterChange(searchFilterChange: string) {
    console.log('Open filter changed:', searchFilterChange);
  }

  onBrandFilterChange(brandFilterValue: any[]) {
    console.log('Selected Brand:', brandFilterValue);
  }

  shouldDisplayAnchor(): boolean {
    // Calculate the condition here, e.g., checking the length of attributeMap
    if (this.msnDetails?.attributeMap) {
      return Object.keys(this.msnDetails.attributeMap).length > 6;
    }
    return false;
  }

  toggleKeyFeatures(msn: string): void {
    this.showAllKeyFeaturesForEachMsn[msn] = !this.showAllKeyFeaturesForEachMsn[msn];
  }

  openMsnPdpPage(msn) {
    window.open("/product-detail?category=" + this.categoryId + "&productId=" + msn);
  }

  capitalizeFirstLetterOfEachWord(input: string): string {
    // Split the string into words
    const words = input.split(' ');

    // Capitalize the first letter of each word
    const capitalizedWords = words.map(word =>
      word.charAt(0).toUpperCase() + word.slice(1)
    );

    // Join the capitalized words back into a single string
    return capitalizedWords.join(' ');
  }


  copyToClipboard(text: string, tooltip: MatTooltip): void {
    navigator.clipboard.writeText(text).then(() => {
      const originalMessage = tooltip.message;
      tooltip.message = 'Copied!';
      tooltip.show();

      setTimeout(() => {
        tooltip.hide();
        tooltip.message = originalMessage;
      }, 500);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  copyToClipboardWithoutImpactOnTabExpantion(text: string, tooltip: MatTooltip, event?: Event): void {
    // Stop event propagation to prevent row expansion
    if (event) {
      event.stopPropagation();
    }

    // Copy to clipboard logic
    navigator.clipboard.writeText(text).then(() => {
      const originalMessage = tooltip.message;
      tooltip.message = 'Copied!';
      tooltip.show();

      setTimeout(() => {
        tooltip.hide();
        tooltip.message = originalMessage;
      }, 500);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

}